import React from "react"
import { ToastNotification } from "@wfp/ui"
import { RootState } from "store/store"
import { useAppSelector } from "hooks/hooksStore"
import useCommon from "hooks/useCommon"

function SnackBarComponent() {
  const { hideSnackBar } = useCommon()
  const { message, type } = useAppSelector((state: RootState) => state.common)

  return message ? (
    <ToastNotification
      style={{
        position: "fixed",
        bottom: 0,
        right: "-15px",
        zIndex: 999999,
        minWidth: "30rem",
      }}
      onCloseButtonClick={() => hideSnackBar()}
      iconDescription="Close notification"
      statusIconDescription=""
      caption=""
      role="alert"
      timeout={7000}
      kind={(type as any) || "success"}
      title={message || ""}
      lowContrast
    />
  ) : null
}

export default SnackBarComponent
